import type {
  IOtherLocaleUrlsContext,
  IOtherLocaleUrlsContextIncomplete,
  LocaleString,
} from '@dreamstack/i18n'
import { RouterOutputs } from '@dreamstack/trpc/client'
import findKey from 'lodash/findKey'
import type { NewsType } from './newsTypeUrls.static'
import { newsTypeUrls } from './newsTypeUrls.static'

export type GetNewsPathOptions = {
  locale: 'en' | 'de'
  newsType: NewsType
  slug: string
}

export const newsBaseUrls: { [key: string]: string } = {
  de: `/${process.env.NEXT_PUBLIC_NEWS_BASE_URL_DE || 'news'}`,
  en: `/${process.env.NEXT_PUBLIC_NEWS_BASE_URL_EN || 'news'}`,
}

export const newsHubOtherLocaleUrls: IOtherLocaleUrlsContext = {
  de: { url: newsBaseUrls.de },
  en: { url: newsBaseUrls.en },
}

export const getNewsPath = ({ locale, newsType, slug }: GetNewsPathOptions) => {
  const baseUrl = newsBaseUrls[locale]
  const newsTypeUrl = getNewsTypeUrlPart({ newsType, locale })
  const path = `${baseUrl}/${newsTypeUrl}/${slug}`
  return path
}

export const getNewsPathOtherLocales = (
  articleDe: RouterOutputs['cms']['getNewsArticle']['otherLocaleArticles']['de'],
  articleEn: RouterOutputs['cms']['getNewsArticle']['otherLocaleArticles']['en']
) => {
  const deExists = true

  // TODO: find out if there is no en version more elegantly/bulletproof
  const enExists =
    articleDe?.title !== articleEn?.title || articleDe?.slug !== articleEn?.slug

  const otherLocaleUrls: IOtherLocaleUrlsContextIncomplete = {
    de:
      deExists && articleDe?.newsType && articleDe?.slug
        ? {
            url: getNewsPath({
              locale: 'de',
              newsType: articleDe?.newsType as NewsType,
              slug: articleDe?.slug,
            }),
          }
        : null,
    en:
      enExists && articleEn?.newsType && articleEn?.slug
        ? {
            url: getNewsPath({
              locale: 'en',
              newsType: articleEn?.newsType as NewsType,
              slug: articleEn?.slug,
            }),
          }
        : null,
  }
  return otherLocaleUrls
}

export const getNewsTypeUrlPart = ({
  newsType,
  locale,
}: Pick<GetNewsPathOptions, 'newsType' | 'locale'>) => {
  return newsTypeUrls[locale][newsType] as string
}

export const getNewsTypeUrlPartReverse = ({
  newsTypeUrl,
  locale,
}: {
  newsTypeUrl: string
  locale: LocaleString
}) => {
  const urlMappings = newsTypeUrls[locale]
  const newsType = findKey(urlMappings, (url) => url === newsTypeUrl)
  return newsType
}
